var receivers = "gvabio@noos.fr";

// var receivers = "pauline@kreature.fr, contact@pauline-beghin.com";


// Create the XHR object.
function createCORSRequest(method, url) {
  var xhr = new XMLHttpRequest();
  if ("withCredentials" in xhr) {
    // XHR for Chrome/Firefox/Opera/Safari.
    xhr.open(method, url, true);
  } else if (typeof XDomainRequest != "undefined") {
    // XDomainRequest for IE.
    xhr = new XDomainRequest();
    xhr.open(method, url);
  } else {
    // CORS not supported.
    xhr = null;
  }
  return xhr;
}

function sendData(data) {
  // var XHR = new XMLHttpRequest();
  // var url = 'https://send.unikkode.com/sendemail';
  // var url = 'https://api.kreature.fr/gvabio/sendemail'
  // var url = 'http://localhost:3000/gvabio/sendemail'
  var url = '/sendemail.php'

  var xhr = createCORSRequest('POST', url);
  // Define what happens on successful data submission
  xhr.addEventListener('load', function(event) {
  	console.log(event);
  	if(200 !== event.target.status)
		alert("Oups! Suite à un problème technique, le message n'a pas été envoyé. Vous pouvez nous envoyer directement un mail à gvabio@noos.fr");
  	else
    	alert('Formulaire envoyé ! Merci !');
  });

  // Define what happens in case of error
  xhr.addEventListener('error', function(event) {
    alert("Oups! Suite à un problème technique, le message n'a pas été envoyé. Vous pouvez nous envoyer directement un mail à gvabio@noos.fr");
  });

  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

  xhr.send(data);
}

module.exports = function () {
  $(document).ready(function(){
    var $form = $('form#formadhesion');
    $form.submit(function(event){
      $("#submit").attr("value","Envoi en cours ...")
      dataSend = $(this).serialize()+"&receivers="+receivers;
      event.preventDefault();
      sendData(dataSend);
      return true;
    });
    return false;
  })
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/js/sendContactForm.js
// module id = 13
// module chunks = 0